import React from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import TextWithAComponent from '../../../components/TextWithAComponent';

const useStyles = makeStyles((theme) => ({
    typ: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    container: {
        margin: '10px',
        // width: '168px',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('md')]: {
            margin: '20px 0'
        },
        [theme.breakpoints.up('md')]: {
            margin: '10px',
        },
    },
}))


const PhoneNumbersComponent = ({ title, content }) => {
    const {t} = useTranslation();
    const classes = useStyles();
    return (
        <Box className={classes.container}>
            <Typography variant='body1' component='h4' className={classes.typ}>
                {t(`phones.${title}`)}
            </Typography>
            <Box mt='10px'>
                <TextWithAComponent text={t(`phones.${content}`)} color={"primary"} />
            </Box>
        </Box >
    )
}


export default PhoneNumbersComponent;